import { createApi } from "@reduxjs/toolkit/query/react";

import { customPlainAuthBaseQuery } from "../../utils/authentication/fetchBaseQuery";
import {
  transformErrorResponse,
  transformSuccessResponse,
} from "../../utils/middleware/responseMiddleware2";

export const automationApi = createApi({
  reducerPath: "automationApi",
  baseQuery: customPlainAuthBaseQuery,
  endpoints: (builder) => ({
    reprocessApplicantResume: builder.mutation({
      query: (data) => ({
        url: "/Automation/ReprocessApplicantResume",
        method: "POST",
        body: data,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse,
    }),
  }),
});

export const { useReprocessApplicantResumeMutation } = automationApi;
